import { Component, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { MatToolbar } from '@angular/material/toolbar';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { ThemeService, Theme } from '../../services/theme.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-menu-header',
  standalone: true,
  imports: [MatToolbar, RouterLink, RouterLinkActive, MatSelectModule, MatIconModule],
  templateUrl: './menu-header.component.html',
  styleUrl: './menu-header.component.scss'
})
export class MenuHeaderComponent {
  readonly appName = environment.appName;
  readonly themeService = inject(ThemeService);

  setTheme(value: string): void {
    this.themeService.set(value as Theme);
  }
}
